import { Button, Grid, Spinner, Typography } from 'gu-ui-kit'
import PropTypes from 'prop-types'
import React, { useEffect } from 'react'
import { Helmet } from 'react-helmet'
import { Trans, useTranslation } from 'react-i18next'
import styles from 'modules/Billing/Billing.module.scss'
import BillingForm from 'modules/Forms/Billing/BillingForm'
import AdmitadWarning from 'modules/Billing/subcomponents/AdmitadWarning'
import Placeholder from 'modules/Billing/subcomponents/Placeholder'
import PaymentMethods from 'modules/Billing/subcomponents/PaymentMethods'
import { useBilling } from 'modules/Forms/Billing/useBilling'
import { ROUTES } from 'constants/routes'
import useGeneratePathI18n from 'utils/hooks/useGeneratePathI18n'
import Billing from 'modules/Forms/Billing/hoc/Billing'
import { IS_APP_PRODUCT_GETUNIQ } from 'utils/constants/product'
import Notification from 'modules/Billing/subcomponents/Notification'
import { useHistory } from 'react-router'
import PageHeader from 'components/PageHeader'
import { TOGGLE_PANEL } from 'modules/Tickets/types'
import { useDispatch } from 'react-redux'

const DepositReplenish = () => {
  const dispatch = useDispatch()
  const pathGen = useGeneratePathI18n()
  const history = useHistory()

  const {
    data: { methods: { loading, loaded, data: methods = [] } = {}, activeMethod } = {},
    setActiveMethod,
    getPaymentMethods,
    getAccountData,
    pushMethods,
  } = useBilling('billing')

  const { t } = useTranslation(['billing'])

  useEffect(() => {
    getPaymentMethods()
  }, [])

  useEffect(() => {
    if (activeMethod?.method === 'admitad') {
      getAccountData({ id: activeMethod.method })
    }
  }, [activeMethod])

  useEffect(
    () => loaded && IS_APP_PRODUCT_GETUNIQ && pushMethods([{ method: 'admitad' }]),
    [loaded],
  )

  return (
    <>
      <Helmet defer={false}>
        <title>{t('head.deposit.title')}</title>
      </Helmet>

      <Billing>
        {!loaded ? (
          <div className={'layout-tile'}>
            <Placeholder />
          </div>
        ) : (
          <>
            <div className={styles['billing__content-top']}>
              <Notification />

              <PageHeader className={'layout-tile margin-bottom-16'}>
                {t('balance_replenishment')}
              </PageHeader>

              {loading && (
                <div className={styles['billing__spinner']}>
                  <Spinner color="Label-GU-Primary" />
                </div>
              )}

              <Grid
                gap={16}
                className={'margin-bottom-16'}
              >
                {loaded && (
                  <PaymentMethods
                    activeMethod={activeMethod}
                    className={'layout-tile'}
                    handleClickSlider={setActiveMethod}
                    methods={methods}
                  />
                )}
              </Grid>

              {activeMethod?.method === 'admitad' ? (
                <AdmitadWarning />
              ) : (
                <div className={'layout-tile'}>
                  <BillingForm onClose={() => history.push(pathGen(ROUTES.FINANCE_WALLETS))} />
                </div>
              )}
            </div>
            <div className={'padding-16'}>
              <Typography
                variant={'Body-Forms-20'}
                color={'Label-Secondary'}
              >
                <Trans i18nKey={'billing::info'}>
                  Средства поступают на ваш баланс сразу. В редких случаях перевод может занять до
                  24 часов. При возникновении проблем обратитесь в
                  <Button
                    color={'Label-GU-Primary'}
                    component={'span'}
                    variant={'link'}
                    onClick={() => dispatch({ type: TOGGLE_PANEL, payload: true })}
                  >
                    тикеты
                  </Button>
                </Trans>
              </Typography>
            </div>
          </>
        )}
      </Billing>
    </>
  )
}

DepositReplenish.propTypes = {
  onClose: PropTypes.func,
}
export default DepositReplenish
